import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-669f327b")

_pushScopeId("data-v-669f327b")
const _hoisted_1 = { slot: "end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_export_button = _resolveComponent("export-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  (_ctx.currentAction == 'reorder')
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        onClick: _ctx.dismissActions,
                        color: "success",
                        fill: "outline"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.checkmarkCircle
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Done')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.currentAction=='reorder')
                ? (_openBlock(), _createBlock(_component_ion_title, {
                    key: 0,
                    color: "success"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Drag to reorder...")), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('To Do')), 1)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_list, { style: {"padding-bottom":"0"} }, {
            default: _withId(() => [
              _createVNode(_component_ion_item, {
                class: "ion-text-center",
                lines: "full"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { style: {"margin":"auto"} }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_button, {
                        disabled: _ctx.currentAction == 'reorder',
                        fill: _ctx.currentAction == 'reorder' ? 'solid' : 'outline',
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentAction('reorder')))
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.reorderFour
                          }, null, 8, ["icon"]),
                          _createTextVNode(_toDisplayString(_ctx.$t('Reorder')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "fill"]),
                      _createVNode(_component_ion_button, {
                        disabled: _ctx.currentAction == 'reorder',
                        fill: _ctx.currentAction == 'create' ? 'solid' : 'outline',
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentAction('create')))
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.addCircle
                          }, null, 8, ["icon"]),
                          _createTextVNode(_toDisplayString(_ctx.$t('New Category')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "fill"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_list, { class: "ion-padding" }, {
            default: _withId(() => [
              _createVNode(_component_ion_reorder_group, {
                disabled: _ctx.currentAction != 'reorder',
                onIonItemReorder: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doReorder($event)))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.store.state.taskGroups, (group) => {
                    return (_openBlock(), _createBlock(_component_ion_reorder, {
                      key: group.id
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_item_sliding, {
                          ref: 'slider' + group.id
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, {
                              color: "secondary",
                              style: {"--inner-border-width":"0px 0px 0px 0px","border-bottom":"0.55px solid white"},
                              button: "",
                              onClick: ($event: any) => (_ctx.itemClicked(group)),
                              detail: "false"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(group.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (_ctx.groupProgress.has(group.id) && _ctx.groupProgress.get(group.id).total && (_ctx.groupProgress.get(group.id).total == _ctx.groupProgress.get(group.id).done))
                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 0,
                                      icon: _ctx.checkmarkCircle,
                                      color: "light",
                                      slot: "end"
                                    }, null, 8, ["icon"]))
                                  : (_ctx.groupProgress.has(group.id))
                                    ? (_openBlock(), _createBlock(_component_ion_note, {
                                        key: 1,
                                        color: "light",
                                        slot: "end"
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.groupProgress.get(group.id).done) + " / " + _toDisplayString(_ctx.groupProgress.get(group.id).total), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_ion_item_options, { side: "end" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_item_option, {
                                  color: "primary-contrast",
                                  onClick: ($event: any) => (_ctx.deleteClicked(group.id))
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.trashOutline,
                                      color: "danger",
                                      style: {"font-size":"30px"}
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1536)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_ion_item, {
                color: "secondary",
                style: {"--inner-border-width":"0px 0px 0px 0px","border-bottom":"0.55px solid white"}
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode(_component_export_button, {
                      useFab: false,
                      endPoint: _ctx.apiEndpoints.exportTasks,
                      shareTitle: "My Wedding ToDo List",
                      shareText: "Attached is your wedding todo list.  We suggest you email to yourself if you don't have Google Sheets or Microsoft Excel."
                    }, null, 8, ["endPoint"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})